import { render } from "./ConfigGameInstance.vue?vue&type=template&id=5e06c506&scoped=true"
import script from "./ConfigGameInstance.vue?vue&type=script&lang=js"
export * from "./ConfigGameInstance.vue?vue&type=script&lang=js"

import "./ConfigGameInstance.vue?vue&type=style&index=0&id=5e06c506&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e06c506"]])

export default __exports__